import { TextButton } from '@gonfalon/launchpad-experimental/Button';
import { Tag, TagGroup } from '@gonfalon/launchpad-experimental/TagGroup';
import { TextTruncator } from '@gonfalon/launchpad-experimental/TextTruncator';
import { TagAutocomplete } from '@gonfalon/tags/components/TagAutocomplete';
import { type TagKind } from '@gonfalon/tags/components/types';
import { Dialog, DialogTrigger, ListBoxItem, Popover } from '@launchpad-ui/components';

export type EntityTagFilterProps = {
  tags: string[];
  kind?: TagKind;
  onChange: (filters: { tags: string[] }) => void;
};
export function EntityTagFilter({ tags, kind, onChange }: EntityTagFilterProps) {
  return (
    <TagGroup
      label="Tags"
      onRemove={(keys) => onChange({ tags: tags.filter((tag) => !keys.has(tag)) })}
      items={tags.map((tag) => ({ id: tag }))}
      renderEmptyState={() => 'Any tag'}
      renderAddTrigger={() => (
        <DialogTrigger>
          <TextButton size="small">Add tag(s)</TextButton>
          <Popover>
            <Dialog>
              <TagAutocomplete
                kind={kind}
                selectedKeys={tags}
                onSelectionChange={(selection) => {
                  if (selection !== 'all') {
                    onChange({
                      tags: Array.from(selection).map((key) => String(key)),
                    });
                  }
                }}
              >
                {(item) => <ListBoxItem id={item.id}>{item.name}</ListBoxItem>}
              </TagAutocomplete>
            </Dialog>
          </Popover>
        </DialogTrigger>
      )}
    >
      {({ id }) => (
        <Tag id={id} textValue={id}>
          <TextTruncator>{id}</TextTruncator>
        </Tag>
      )}
    </TagGroup>
  );
}
